// Interfaces
import { IAccessDialog } from "./interfaces";

// Layouts
import Button from "@/Layouts/components/Buttons/Button";

// MUI
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const AccessDialog = (props: IAccessDialog) => {
	const { children, title = "Access", open = false, onAcceptAction = () => {}, onCloseAction = () => {}, buttonText = "Add" } = props;

	return (
		<Dialog
			disableEscapeKeyDown
			fullWidth
			PaperProps={{
				className: "!rounded-[10px]",
			}}
			maxWidth={"md"}
			open={open}
			onClose={onCloseAction}
		>
			<DialogTitle className="!p-6">
				<Typography className={"!font-montserrat !text-2xl text-default !font-medium"}>{title}</Typography>
				<IconButton
					aria-label="close"
					sx={{
						position: "absolute",
						right: 24,
						top: 20,
						color: (theme) => theme.palette.grey[500],
					}}
					onClick={onCloseAction}
				>
					<CloseRoundedIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent className="h-[38rem] !p-0">{children}</DialogContent>
			<DialogActions className="!p-6">
				<Button
					variant="contained"
					text={buttonText}
					classes="tier-btn !bg-primary hover:!shadow-primary-shadow-50 h-[30px] !rounded-[6px] btn-regular-text"
					bgColor={"var(--primary-color)"}
					onClick={onAcceptAction}
					sx={{ textTransform: "unset !important" }}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default AccessDialog;
